export default [
    {
        url: require('./images/one.jpg')
    },
    {
        url: require('./images/two.jpg')
    },
    {
        url: require('./images/three.jpg')
    },
    {
        url: require('./images/four.jpg')
    },
    {
        url: require('./images/five.jpg')
    },
    {
        url: require('./images/six.jpg')
    },
    {
        url: require('./images/seven.jpg')
    },
    {
        url: require('./images/eight.jpg')
    },
    {
        url: require('./images/nine.jpg')
    },
    {
        url: require('./images/ten.jpg')
    },
    {
        url: require('./images/eleven.jpg')
    },
    {
        url: require('./images/twelve.jpg')
    }
    
]